import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const { user, hasPermission, hasAnyPermission, hasAllPermissions, getUserPermissions, canAccessModule } = useAuth();

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    getUserPermissions,
    canAccessModule,
    
    // Specific permission checkers for common use cases
    canViewPrerequisites: () => hasPermission('view_prerequisites'),
    canManagePrerequisites: () => hasPermission('manage_prerequisites'),
    canViewAttendance: () => hasPermission('view_attendance'),
    canManageAttendance: () => hasPermission('manage_attendance'), 
    canViewCourses: () => hasPermission('view_courses'),
    canManageCourses: () => hasPermission('manage_courses'),
    canViewCourseBuilder: () => hasPermission('view_course_builder'),
    canManageCourseBuilder: () => hasPermission('manage_course_builder'),
    canViewTempCards: () => hasPermission('view_temp_cards'),
    canManageTempCards: () => hasPermission('manage_temp_cards'),
    canViewTestSheetSubmissions: () => hasPermission('view_test_sheet_submissions'),
    canManageTestSheetSubmissions: () => hasPermission('manage_test_sheet_submissions'),
    canViewDOBVerifier: () => hasPermission('view_dob_verifier'),
    canManageDOBVerifier: () => hasPermission('manage_dob_verifier'),
    canManageUsers: () => hasPermission('manage_users'),
    isAdmin: () => user?.role === 'admin' || hasPermission('admin_access'),
    
    // Module access checkers
    canAccessPrerequisites: () => canAccessModule('prerequisites'),
    canAccessAttendance: () => canAccessModule('attendance'),
    canAccessCourses: () => canAccessModule('courses'),
    canAccessCourseBuilder: () => canAccessModule('course_builder'),
    canAccessTempCards: () => canAccessModule('temp_cards'),
    canAccessTestSheetSubmissions: () => canAccessModule('test_sheet_submissions'),
    canAccessDOBVerifier: () => canAccessModule('dob_verifier'),
    canAccessUserManagement: () => canAccessModule('users'),
  };
};
